<template>
  <div>
    <div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="row mb-2">
                <div class="col-10 my-auto">
                  <input
                    v-if="editPSRSetMode"
                    v-model="activePSRSet.Name"
                    type="text"
                    class="w-100 border border-secondaryL brs text-left pl-2 pb-1 pt-1"
                    pattern="^[A-Za-z -]+$"
                  />
                  <h3 v-else class="d-inline font-weight-bold ml-1">{{activePSRSet.Name}}</h3>
                </div>
                <div class="col-2 my-auto">
                  <i
                    class="float-right pointer pr-2 fas fa-edit fas-lg"
                    v-if="!disableEdit && !editPSRSetMode"
                    @click="toggleEditPSRSetMode(true)"
                  ></i>
                </div>
              </div>

              <!-- <hr /> -->

              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-xl-4 col-sm-5">
                      <p class="font-weight-bold mb-0">Password:</p>
                    </div>
                    <div class="col-xl-8 col-sm-7">
                      <input
                        v-if="editPSRSetMode"
                        v-model="activePSRSet.Password"
                        type="text"
                        class="w-100 border border-secondaryL brs text-left pl-2 pb-1 pt-1"
                        pattern="^[A-Za-z -]+$"
                      />
                      <p v-else>{{activePSRSet.Password}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-xl-4 col-sm-5">
                      <p class="font-weight-bold mb-0">Notes:</p>
                    </div>
                    <div class="col-xl-8 col-sm-7">
                      <textarea
                        v-if="editPSRSetMode"
                        v-model="activePSRSet.Notes"
                        type="text"
                        class="w-100 border border-secondaryL brs text-left pl-2 pb-1 pt-1"
                        pattern="^[A-Za-z -]+$"
                      />
                      <p v-else>{{activePSRSet.Notes}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div v-if="editPSRSetMode">
                <div class="row">
                  <div class="col-12">
                    <div>
                      <div class="text-left float-right">
                        <b-btn @click="toggleEditPSRSetMode(false)" class="btn btn-hc mr-1">Cancel</b-btn>
                        <b-btn @click="savePSRSetChanges()" class="btn btn-hc ml-1">
                          Save
                          Changes
                        </b-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="mt-4" />
              </div>
              <div class="row mb-2">
                <div class="col-10 my-auto">
                  <p class="d-inline font-weight-bold">Priority Services</p>
                </div>
                <div class="col-2 d-inline my-auto">
                  <a
                    class="btn btn-hc-nb float-right"
                    role="button"
                    @click="$bvModal.show('addPriorityService')"
                  >
                    <img src="@/assets/img/add_icon_hcg.png" class="d-inline-block" alt="Add Icon" />
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="bg-secondaryL p-2 W-100">
                    <div class="table-responsive-lg">
                      <b-table
                        striped
                        fixed
                        small
                        sort-by="PsrType"
                        :items="activePSRSet.PriorityServices"
                        :fields="priorityServiceFields"
                      >
                        <template slot="PsrType" slot-scope="data">{{wordSplit(data.item.PsrType)}}</template>

                        <template slot="PsrSpecificDetails" slot-scope="data">
                          <div v-if="data.item.PsrSpecificDetails">{{data.item.PsrSpecificDetails}}</div>
                        </template>

                        <template slot="EffectiveToDate" slot-scope="data">
                          <div
                            v-if="data.item.EffectiveToDate"
                          >{{data.item.EffectiveToDate | moment('Do MMMM YYYY')}}</div>
                          <div v-else>N/A</div>
                        </template>

                        <template slot="Actions" slot-scope="row">
                          <div class="d-flex w-100 justify-content-center align-self-center">
                            <i
                              class="float-right pointer fas fa-edit mt-2 mx-2"
                              @click="toggleDetails(row, !row.detailsShowing)"
                            ></i>
                            <i
                              class="float-right pointer fas fa-trash mt-2 mx-2"
                              @click="toggleDeleteConfirmation(row)"
                            ></i>
                          </div>
                        </template>
                        <template slot="row-details" slot-scope="row">
                          <b-card>
                            <hr class="mt-4" />
                            <div class="row text-left">
                              <div class="col-sm-6">
                                <div class="row">
                                  <div class="col-12">
                                    <p class="font-weight-bold text-left pl-2">Details</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <textarea
                                      type="text"
                                      class="w-100 border brs border-secondaryL form-control"
                                      v-model="row.item.PsrSpecificDetails"
                                      :disabled="!editPriorityServiceMode"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-sm-6"
                                v-if="row.item.PsrType == 'FamiliesWithYoungChildren5OrUnder' || row.item.PsrType == 'TemporaryLifeChanges' || row.item.PsrType == 'TemporaryPostHospitalRecovery' || row.item.PsrType == 'TemporaryYoungAdultHouseholder'"
                              >
                                <div class="row">
                                  <div class="col-12">
                                    <p class="font-weight-bold text-left pl-2">Effective To</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <el-date-picker
                                      v-model="row.item.EffectiveToDate"
                                      format="dd MMMM yyyy"
                                      :disabled="!editPriorityServiceMode"
                                      :clearable="false"
                                    ></el-date-picker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr class="mt-4" />

                            <div v-if="editPriorityServiceMode">
                              <div class="row">
                                <div class="col-12">
                                  <div>
                                    <div class="text-left float-right">
                                      <b-btn
                                        @click="toggleDetails(row, false)"
                                        class="btn btn-hc mr-1"
                                      >Cancel</b-btn>
                                      <b-btn @click="saveAndClose(row)" class="btn btn-hc ml-1">
                                        Save
                                        Changes
                                      </b-btn>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="deletePriorityService">
      <template slot="modal-header" slot-scope="{ close }">
        <div class="container-fluid">
          <div class="row">
            <div class="col-9 my-auto">
              <h5 class="modal-title">Delete Priority Service</h5>
            </div>
            <div class="col-3 my-auto">
              <div>
                <div>
                  <span>
                    <a class="close">
                      <i
                        class="far fa-times-circle fa-2x"
                        @click="close()"
                        id="closeDeletePriorityService"
                        aria-label="Close"
                      ></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="default">
        <p class="my-4 text-center">Are you sure you want to delete this priority service?</p>
      </template>
      <template slot="modal-footer" slot-scope="{ close }">
        <button type="submit" class="btn btn-hc float-right" @click="deletePriorityService">Yes</button>
        <button type="submit" class="btn btn-hc float-right" @click="close()">No</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import { _ } from "underscore";

export default {
  data() {
    return {
      nominatedPriorityServiceIndex: null,
      priorityServiceFields: {
        PsrType: {
          label: "Category",
          class: "text-left"
        },
        PsrSpecificDetails: {
          label: "Details",
          class: "text-left",
          sortable: true
        },
        EffectiveToDate: {
          label: "Effective To",
          class: "text-left",
          sortable: true
        },
        Actions: {
          label: "",
          class: ""
        }
      }
    };
  },
  computed: {
    PSRsets() {
      return this.$store.state.contracts.customerLevelPriorityServices;
    },
    activePSRSet: {
      get() {
        return this.$store.state.contracts.activePSRSet;
      },
      set(set) {
        this.$store.commit("updateActivePSRSet", set);
      }
    },
    activeContract: {
      get() {
        return this.$store.state.contracts.activeContract;
      },
      set(contract) {
        this.$store.commit("updateActiveContract", contract);
      }
    },
    editPSRSetMode: {
      get() {
        return this.$store.state.contracts.editPSRSetMode;
      },
      set(flag) {
        this.$store.commit("updateEditPSRSetMode", flag);
      }
    },
    editPriorityServiceMode: {
      get() {
        return this.$store.state.contracts.editPriorityServiceMode;
      },
      set(flag) {
        this.$store.commit("updateEditPriorityServiceMode", flag);
      }
    },
    
    disableEdit() {
      return this.activeContract.ContractStatus == 'NotChargeable';
    },
  },
  methods: {
    saveChangesAndClose(row) {
      this.savePSRSetChanges();
      row.toggleDetails();
    },
    toggleDetails(row, edit) {
      if (edit && !this.editPriorityServiceMode) {
        this.beforeEditingPriorityService = Object.assign({}, row.item);
        this.beforeEditingSet = Object.assign({}, this.activePSRSet);
        if (!row.item.hasOwnProperty("PsrSpecificDetails")) {
          this.beforeEditingPriorityService.PsrSpecificDetails = undefined;
        }
        if (!row.item.hasOwnProperty("EffectiveToDate")) {
          this.beforeEditingPriorityService.EffectiveToDate = undefined;
        }
      }
      row.toggleDetails();
      if (!edit && this.editPriorityServiceMode) {
        Object.assign(row.item, this.beforeEditingPriorityService);
        Object.assign(this.activePSRSet, this.beforeEditingSet);
      }
      this.editPriorityServiceMode = edit;
    },
    toggleEditPSRSetMode(bool) {
      if (bool && !this.editPSRSetMode) {
        this.beforeEditingSet = Object.assign({}, this.activePSRSet);
      }
      if (!bool && this.editPSRSetMode) {
        Object.assign(this.activePSRSet, this.beforeEditingSet);
      }
      this.editPSRSetMode = bool;
    },
    toggleDeleteConfirmation(row) {
      this.$bvModal.show("deletePriorityService");
      this.nominatedPriorityServiceIndex = _.findIndex(
        this.activePSRSet.PriorityServices,
        function(service) {
          return _.isEqual(service, row.item);
        }
      );
    },
    deletePriorityService() {
      this.activePSRSet.PriorityServices.splice(
        this.nominatedPriorityServiceIndex,
        1
      );
      this.savePSRSetChanges();
      document.getElementById("closeDeletePriorityService").click();
    },
    saveAndClose(row) {
      this.savePSRSetChanges();
      this.toggleDetails(row, true);
    },
    savePSRSetChanges() {
      // this.$http
      //   .put(
      //     "https://" +
      //       Vue.config.honeycomb.queenbee.domain +
      //       "/api/v1/contracts/" +
      //       this.activeContract.Id +
      //       "/priorityServices/" +
      //       this.activePSRSet.Id,
      //     this.activePSRSet,
      //     {
      //       withCredentials: true
      //     }
      //   )
      this.$http
        .put(
          "https://" +
            Vue.config.honeycomb.contractbot.domain +
            "/api/v1/PriorityServices/" +
            this.activePSRSet.Id,
          this.activePSRSet,
          {
            withCredentials: true
          }
        )
        .then(response => {
          Swal({
            toast: true,
            position: "top-end",
            type: "success",
            title: "Success! Changes saved.",
            showConfirmButton: false,
            timer: 2500
          });
          this.activeContract = response.data;
          // this.activePSRSet = response.data.PriorityServices.filter(
          //   set => set.Id == this.activePSRSet.Id
          // )[0];
          this.$store.dispatch("getContracts");
          this.editPSRSetMode = false;
          this.editPriorityServiceMode = false;
        })
        .catch(error => {
          Object.assign(this.activePSRSet, this.beforeEditingSet);
          if (error.response) {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: error.response.data.UserDescription + " Error",
              showConfirmButton: false,
              timer: 2500
            });
          } else if (error.request) {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: "No response recieved",
              showConfirmButton: false,
              timer: 2500
            });
          } else {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: error,
              showConfirmButton: false,
              timer: 2500
            });
          }
        });
    }
  }
};
</script>